const Integrations = () => {
  return (
    <section className="section-padding bg-white">
      <div className="container-custom">
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-center mb-12 sm:mb-16 text-accent">
          Real-Time Reserves Integrations
        </h2>

        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {/* Blockchains */}
          <div className="bg-gray-50 rounded-2xl p-6 sm:p-8 border-2 border-gray-200 hover:border-accent transition-colors">
            <h3 className="text-xl sm:text-2xl font-bold mb-6 text-gray-900">Blockchains</h3>
            <div className="space-y-3">
              {['Bitcoin', 'Ethereum', 'Litecoin', 'XRP', 'Polkadot', 'Cardano', 'Algorand', 'Solana'].map((item, idx) => (
                <div key={idx} className="flex items-center gap-3">
                  <svg className="w-5 h-5 text-accent flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  <span className="text-gray-700 font-medium">{item}</span>
                </div>
              ))}
              <div className="flex items-center gap-3">
                <svg className="w-5 h-5 text-accent flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
                <span className="text-gray-700 font-medium italic">And more!</span>
              </div>
            </div>
          </div>

          {/* Banks */}
          <div className="bg-gray-50 rounded-2xl p-6 sm:p-8 border-2 border-gray-200 hover:border-accent transition-colors">
            <h3 className="text-xl sm:text-2xl font-bold mb-6 text-gray-900">Banks</h3>
            <div className="space-y-3">
              {['First Digital Trust', 'Flowbank', 'Capital Union Bank', 'Customers Bank', 'Fortress Trust', 'Deltec', 'J.P. Morgan Chase', 'Cross River Bank'].map((item, idx) => (
                <div key={idx} className="flex items-center gap-3">
                  <svg className="w-5 h-5 text-accent flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  <span className="text-gray-700 font-medium">{item}</span>
                </div>
              ))}
              <div className="flex items-center gap-3">
                <svg className="w-5 h-5 text-accent flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
                <span className="text-gray-700 font-medium italic">And more!</span>
              </div>
            </div>
          </div>

          {/* Custodians & Exchanges */}
          <div className="bg-gray-50 rounded-2xl p-6 sm:p-8 border-2 border-gray-200 hover:border-accent transition-colors">
            <h3 className="text-xl sm:text-2xl font-bold mb-6 text-gray-900">Custodians & Exchanges</h3>
            <div className="space-y-3">
              {['Coinbase', 'Binance.com', 'Kraken', 'Bitgo', 'Komainu', 'OKEX', 'Huobi', 'Bitfinex, Bitstamp, Deribit'].map((item, idx) => (
                <div key={idx} className="flex items-center gap-3">
                  <svg className="w-5 h-5 text-accent flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  <span className="text-gray-700 font-medium">{item}</span>
                </div>
              ))}
              <div className="flex items-center gap-3">
                <svg className="w-5 h-5 text-accent flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
                <span className="text-gray-700 font-medium italic">LMAX, B2C2, OSL, Pit, and more!</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Integrations;
